const cookiePrefix =
  process.env.NEXT_PUBLIC_COOKIE_PREFIX || process.env.COOKIE_PREFIX || "";

export const accessTokenName = `${cookiePrefix}.accessToken`;
export const refreshTokenName = `${cookiePrefix}.refreshToken`;
export const idTokenName = `${cookiePrefix}.idToken`;
